import { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import RevendeurInfos from "../../components/revendeurs/revendeurinfos";



export default function ViewRevendeur() {
    // states
    let code = useParams();
    const [page, setPage] = useState(0);
    const { user } = useContext(UserContext);

    const displayPages = () => {
        if (page === 0) {
            return <RevendeurInfos code={code.code} />;
        }
        //  else {
        //     return <TypeConges />;
        // }
    }

    // affichages
    return (
        <div className="container-fluid">
        <h1 className="h4 mb-4 font-weight-bold text_primary"><i className="fa fa-users mr-1"></i> Revendeurs</h1>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                {/* <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>Informations du revendeur</span>
                </button> */}
                {/* <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.shiftemployelabel}</span>
                </button> */}
            </div>
            {displayPages()}
        </div>
    )

}